export const SEO = {
  SEO_CONTENT_ID: 'seo_components',
};
